import React from 'react';
import IntlMessages from '../components/IntlMessage';
import { mergeContentExtraMenuPaths } from './extraMenuPaths';
import {
  ScheduleOutlined,
  DollarCircleOutlined,
  MessageOutlined,
  HomeOutlined,
  UserOutlined,
  SettingOutlined,
  LineChartOutlined,
  PayCircleOutlined,
  EnvironmentOutlined,
  FileDoneOutlined,
  ToolOutlined,
  UsergroupAddOutlined,
  NodeIndexOutlined,
  ApartmentOutlined,
  ShoppingOutlined,
  GlobalOutlined,
  BarChartOutlined,
  FileOutlined,
  RedEnvelopeOutlined,
  LikeOutlined,
  TransactionOutlined,
  CheckOutlined,
  SwitcherOutlined,
  WalletOutlined,
  UserSwitchOutlined,
  PieChartOutlined,
  NotificationOutlined,
  PercentageOutlined,
  CopyrightOutlined,
  AppstoreAddOutlined,
  AppstoreOutlined,
  UnlockOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  ShoppingCartOutlined,
  GiftOutlined,
  ShopOutlined,
  ToolFilled,
  ApiOutlined,
  ExperimentOutlined,
  ControlOutlined,
  BankOutlined,
  ShareAltOutlined,
  BellOutlined,
  SolutionOutlined,
  CreditCardOutlined,
  TagsOutlined,
  TranslationOutlined,
  StarOutlined,
  GiftFilled,
  DollarOutlined,
  HistoryOutlined,
  MoneyCollectOutlined,
  CloudOutlined,
  UnorderedListOutlined,
  KeyOutlined,
  HeartOutlined,
  AudioOutlined,
  AlertOutlined,
  DashboardOutlined,
  SoundOutlined,
  CommentOutlined,
  TagOutlined,
  RobotOutlined,
  AccountBookOutlined,
  ThunderboltOutlined,
  RiseOutlined,
  FireOutlined,
  SearchOutlined,
  EyeOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  ContactsOutlined,
  MailOutlined,
  FundProjectionScreenOutlined,
  RadarChartOutlined,
  AimOutlined,
  SafetyCertificateOutlined,
  DotChartOutlined,
  LinkOutlined,
  MobileOutlined,
  FieldTimeOutlined,
  PictureOutlined,
} from '@ant-design/icons';

/** Tạm ẩn menu Search v2. Đổi thành true để hiện lại. */
export const SHOW_SEARCH_V2 = true;
const menu = [
  {
    key: '/app/home',
    label: <IntlMessages id="global.home" />,
    icon: <HomeOutlined />,
    permission: null,
    children: null,
  },
  {
    key: 'user',
    label: <IntlMessages id="global.users" />,
    icon: <UsergroupAddOutlined />,
    permission: null,
    children: [
      {
        key: '/app/users',
        label: <IntlMessages id="global.users" />,
        icon: <UserSwitchOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/organization-application',
        label: <IntlMessages id="global.organization_application" />,
        icon: <FileDoneOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/organization-invitations',
        label: <IntlMessages id="global.organization_invitations" />,
        icon: <PercentageOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seed-buyer',
        label: <IntlMessages id="global.seed_buyer" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/reviews',
        label: <IntlMessages id="global.review" />,
        icon: <LikeOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/interests',
        label: <IntlMessages id="global.interests" />,
        icon: <StarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/service-sample',
        label: <IntlMessages id="serviceSample.menu_title" />,
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/experts',
        label: <IntlMessages id="global.professionals_report" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/user-relationships',
        label: <IntlMessages id="global.network" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/hr-users',
        label: 'HR Users',
        icon: <SolutionOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/sale-users',
        label: 'Sale Users',
        icon: <SolutionOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/sale-profile-users',
        label: 'Sale Profile Users',
        icon: <SolutionOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    // Nhóm Seller: các trang về seller tách khỏi Users cho dễ tìm. Chỉ hiện khi
    // role được cấp ít nhất một trang con (AppSidebar lọc theo đường dẫn).
    key: 'seller',
    label: 'Seller',
    icon: <ShopOutlined />,
    permission: null,
    children: [
      {
        key: '/app/seller',
        label: <IntlMessages id="global.menu_sidebar_seller" />,
        icon: <UserOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seller-about-score',
        label: 'Seller About AI score',
        icon: <RobotOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/provider-verification',
        label: 'Provider verification',
        icon: <SafetyCertificateOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/professions',
        label: <IntlMessages id="global.professions" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'finance',
    label: <IntlMessages id="global.finance" />,
    icon: <DollarOutlined />,
    permission: null,
    children: [
      {
        key: '/app/finance-home',
        label: 'Finance Dashboard',
        icon: <DashboardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/user-revenue',
        label: <IntlMessages id="global.user_revenue" />,
        icon: <TransactionOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/customer-receivables',
        label: <IntlMessages id="global.customer_receivables" />,
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/reports-finance',
        label: <IntlMessages id="global.reports" />,
        icon: <BarChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/withdrawal',
        label: <IntlMessages id="global.withdrawal" />,
        icon: <MoneyCollectOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/subscriptions',
        label: <IntlMessages id="global.subscriptions" />,
        icon: <UnorderedListOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/provider-wallet',
        label: 'Provider Wallet Management',
        icon: <WalletOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/provider-payout',
        label: 'Provider Payout Management',
        icon: <MoneyCollectOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/ledger',
        label: 'Ledger Management',
        icon: <AccountBookOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/payment-in',
        label: 'Payment In Management',
        icon: <PayCircleOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/platform-account',
        label: 'Platform Account Management',
        icon: <BankOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/finance-cost-links',
        label: <IntlMessages id="global.finance_cost_links" />,
        icon: <LinkOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'promotions',
    label: <IntlMessages id="global.promotions" />,
    icon: <ShopOutlined />,
    permission: null,
    children: [
      {
        key: '/app/vouchers',
        label: <IntlMessages id="global.vouchers" />,
        icon: <GiftOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'service_order',
    label: <IntlMessages id="global.service_order" />,
    icon: <ShoppingCartOutlined />,
    permission: null,
    children: [
      {
        key: '/app/offers',
        label: <IntlMessages id="global.offers" />,
        icon: <PieChartOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'product_order',
    label: <IntlMessages id="global.product_order" />,
    icon: <GiftOutlined />,
    permission: null,
    children: [
      {
        key: '/app/orders/product',
        label: <IntlMessages id="global.product_order" />,
        icon: <GiftFilled />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'request',
    label: <IntlMessages id="global.requests" />,
    icon: <ControlOutlined />,
    permission: null,
    children: [
      {
        key: '/app/requests',
        label: <IntlMessages id="global.request" />,
        icon: <ControlOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/requests-pending-approval',
        label: <IntlMessages id="global.requests_pending_approval_title" defaultMessage="Pending Approval" />,
        icon: <SafetyCertificateOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/public-offers',
        label: <IntlMessages id="global.public_offers_title" defaultMessage="Public Offers" />,
        icon: <NotificationOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/request-seed',
        label: <IntlMessages id="global.request_seed_title" defaultMessage="Request Seed" />,
        icon: <ExperimentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/request-image',
        label: <IntlMessages id="global.request_image_title" defaultMessage="Request Image" />,
        icon: <PictureOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/request-refine',
        label: 'Request AI Refine',
        icon: <RobotOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'service',
    label: <IntlMessages id="global.service" />,
    icon: <ApiOutlined />,
    permission: null,
    children: [
      {
        key: '/app/services',
        label: <IntlMessages id="Services" />,
        icon: <AppstoreAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/services/create-logs',
        label: 'Create logs',
        icon: <AppstoreAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/appointment-requests',
        label: <IntlMessages id="appointment_request.title" />,
        icon: <ScheduleOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/longevity-consults',
        label: <IntlMessages id="longevity_consult.title" />,
        icon: <HeartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/service-refine',
        label: 'Service AI Refine',
        icon: <RobotOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/service-sessions',
        label: 'Sessions & Appointments',
        icon: <AppstoreAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/instructors',
        label: 'Instructors',
        icon: <AppstoreAddOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'clinic',
    label: 'Organization',
    icon: <BankOutlined />,
    permission: null,
    children: [
      {
        key: '/app/organization',
        label: 'Organization',
        icon: <BankOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/amenities',
        label: 'Amenities',
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'product',
    label: <IntlMessages id="global.products" />,
    icon: <ShopOutlined />,
    permission: null,
    children: [
      {
        key: '/app/products',
        label: <IntlMessages id="global.product" />,
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/brand',
        label: <IntlMessages id="global.brand" />,
        icon: <TagsOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'supplier',
    label: <IntlMessages id="global.supplier" />,
    icon: <ShoppingOutlined />,
    permission: null,
    children: [],
  },
  {
    key: 'affiliate',
    label: <IntlMessages id="global.affiliate" />,
    icon: <NodeIndexOutlined />,
    permission: null,
    children: [
      {
        key: '/app/affcampaign',
        label: <IntlMessages id="global.affcampaign" />,
        icon: <LineChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/pro-referral',
        label: <IntlMessages id="pro_referral.menu" />,
        icon: <GiftOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/campaign-user',
        label: <IntlMessages id="global.campaignUser" />,
        icon: <UserSwitchOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/conversion',
        label: <IntlMessages id="global.conversion" />,
        icon: <CheckOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/click',
        label: <IntlMessages id="global.clicks" />,
        icon: <ShareAltOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/affiliate-tier',
        label: (
          <IntlMessages
            id="global.affiliate_tier"
            defaultMessage="Affiliate Tier"
          />
        ),
        icon: <StarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/affiliate-tier-history',
        label: (
          <IntlMessages
            id="global.affiliate_tier_history"
            defaultMessage="Affiliate Tier History"
          />
        ),
        icon: <HistoryOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/affiliate-tier-users',
        label: (
          <IntlMessages
            id="global.affiliate_tier_users"
            defaultMessage="User Tiers"
          />
        ),
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'google_ads',
    label: 'Google Ads',
    icon: <GlobalOutlined />,
    permission: null,
    children: [
      {
        key: '/app/google-ads/campaigns',
        label: <IntlMessages id="google_ads.campaigns" />,
        icon: <LineChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/google-ads/cost',
        label: <IntlMessages id="google_ads.cost_report" />,
        icon: <DollarOutlined />,
        permission: null,
        children: null,
      },

      {
        key: '/app/google-ads/daily',
        label: <IntlMessages id="google_ads.daily_report" />,
        icon: <LineChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/google-ads/install',
        label: <IntlMessages id="google_ads.install_report" />,
        icon: <AppstoreAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/google-ads/appsflyer-media-source',
        label: <IntlMessages id="appsflyer.media_source_button" />,
        icon: <BarChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/google-ads/appsflyer-report',
        label: <IntlMessages id="appsflyer.report_button" />,
        icon: <FileTextOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'traffic_website',
    label: 'Traffic',
    icon: <FundProjectionScreenOutlined />,
    permission: null,
    children: [
      {
        key: '/app/traffic-website/posthog-event-users-app',
        label: 'App Multime AI',
        icon: <DotChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/traffic-website/posthog-users-website',
        label: 'Website StrongBody AI',
        icon: <RadarChartOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/traffic-website/traffic-country-website',
        label: 'Traffic Country Website',
        icon: <AimOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/tracking-pages',
        label: <IntlMessages id="trackingPage.menu" />,
        icon: <AimOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/whatsapp-messages',
        label: 'WhatsApp OTP',
        icon: <AimOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'tools',
    label: <IntlMessages id="global.tools" />,
    icon: <ExperimentOutlined />,
    permission: null,
    children: [
      {
        key: '/app/landing-page',
        label: <IntlMessages id="global.landing_page" />,
        icon: <FileTextOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/subscribers',
        label: <IntlMessages id="global.subscribers" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/subscription-plans',
        label: <IntlMessages id="global.subscription_plans" />,
        icon: <SolutionOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/virtual-views/add',
        label: 'Virtual Views Manager',
        icon: <EyeOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/virtual-views/list',
        label: 'Virtual Views List',
        icon: <UnorderedListOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/quick-quest/templates',
        label: 'Quick Quest Templates',
        icon: <QuestionCircleOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/outreach/campaigns',
        label: 'Outreach',
        icon: <ShareAltOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/ad-image-generator',
        label: 'Agent dựng ảnh quảng cáo',
        icon: <PictureOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'reports-all',
    label: <IntlMessages id="global.reports" />,
    icon: <BarChartOutlined />,
    permission: null,
    children: null,
  },
  {
    key: 'content',
    label: <IntlMessages id="global.content" />,
    icon: <FileTextOutlined />,
    permission: null,
    children: [
      {
        key: '/app/health-solution',
        label: <IntlMessages id="healthSolution.menu_title" />,
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/library-category',
        label: <IntlMessages id="libraryCategory.menu_title" />,
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/posts',
        label: <IntlMessages id="global.posts" />,
        icon: <ApartmentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/partner-recruitment-page',
        label: 'Partner Recruitment Page',
        icon: <FileTextOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/testimonials',
        label: 'Testimonials',
        icon: <FileTextOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seo-support',
        label: 'Seo Support',
        icon: <FileSearchOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/wellness-test',
        label: 'Wellness Test',
        icon: <FileTextOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/faq',
        label: <IntlMessages id="global.faq" />,
        icon: <FileDoneOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/templates',
        label: <IntlMessages id="global.templates" />,
        icon: <FileOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/brevo-contact',
        label: 'Brevo Contact Lists',
        icon: <ContactsOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/widgets',
        label: <IntlMessages id="global.widgets" />,
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/ldp-inquiries',
        label: 'LDP Inquiries',
        icon: <FileTextOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/ldp-inquiry-send-emails',
        label: 'LDP Inquiry Send Emails',
        icon: <MailOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/landing-page-search',
        label: 'LDP Search',
        icon: <SearchOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'seller_interview',
    label: <IntlMessages id="interview_question.menu_group" defaultMessage="Voice Onboarding" />,
    icon: <AudioOutlined />,
    permission: null,
    children: [
      {
        key: '/app/interview-question',
        label: <IntlMessages id="interview_question.menu" defaultMessage="Interview Questions" />,
        icon: <QuestionCircleOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/interview-flow',
        label: <IntlMessages id="interview_flow.menu" defaultMessage="Seller Interview Flows" />,
        icon: <ApartmentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/interview-session',
        label: <IntlMessages id="interview_session.menu" defaultMessage="Interview Sessions" />,
        icon: <FileDoneOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'notification_channels',
    label: <IntlMessages id="global.notification_channels" />,
    icon: <BellOutlined />,
    permission: null,
    children: [
      {
        key: '/app/notification-config',
        label: <IntlMessages id="global.notification_config" />,
        icon: <SettingOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/notification-channels',
        label: <IntlMessages id="global.notification_channels" />,
        icon: <ApiOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/notification-all',
        label: <IntlMessages id="global.notification_all" />,
        icon: <BellOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  // Tạm ẩn Search v2 (Search Index / Playground). Bật lại: SHOW_SEARCH_V2 = true.
  ...(SHOW_SEARCH_V2
    ? [
        {
          key: 'search_v2',
          label: 'Search',
          icon: <SearchOutlined />,
          permission: null,
          children: [
            {
              key: '/app/search-index',
              label: 'Search Index',
              icon: <FileSearchOutlined />,
              permission: null,
              children: null,
            },
            {
              key: '/app/search-playground',
              label: 'Search Playground',
              icon: <ExperimentOutlined />,
              permission: null,
              children: null,
            },
            {
              key: '/app/search-assistant',
              label: 'Search Assistant',
              icon: <AudioOutlined />,
              permission: null,
              children: null,
            },
            {
              key: '/app/search-assistant-logs',
              label: 'Assistant Logs',
              icon: <HistoryOutlined />,
              permission: null,
              children: null,
            },
          ],
        },
      ]
    : []),
  {
    key: 'systems',
    label: <IntlMessages id="global.systems" />,
    icon: <ToolOutlined />,
    permission: null,
    children: [
      {
        key: '/app/app-all',
        label: <IntlMessages id="global.app-all" />,
        icon: <AppstoreAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/roles',
        label: <IntlMessages id="global.roles" />,
        icon: <UnlockOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/admin-2fa',
        label: 'Admin 2FA',
        icon: <SafetyCertificateOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/countries',
        label: <IntlMessages id="global.countries" />,
        icon: <CopyrightOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/languages',
        label: 'Languages',
        icon: <TranslationOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/categories',
        label: <IntlMessages id="global.categories" />,
        icon: <ApartmentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/sites',
        label: <IntlMessages id="global.sites" />,
        icon: <EnvironmentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/permissions',
        label: <IntlMessages id="global.permissions" />,
        icon: <FileDoneOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/currencies',
        label: <IntlMessages id="global.currencies" />,
        icon: <DollarCircleOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/notifications',
        label: <IntlMessages id="global.notifications" />,
        icon: <BellOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/system-log',
        label: <IntlMessages id="global.system_log" />,
        icon: <HistoryOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/event-log',
        label: 'Event Log',
        icon: <HistoryOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/app-settings',
        label: <IntlMessages id="global.app-settings" />,
        icon: <PayCircleOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/cold-start-settings',
        label: 'Cold Start Settings',
        icon: <SettingOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/cold-start-activity',
        label: 'Cold Start Activity',
        icon: <ThunderboltOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/file-manager',
        label: <IntlMessages id="global.file_manager" />,
        icon: <CloudOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/health-check',
        label: 'Health Check',
        icon: <HeartOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'menu_manager',
    label: <IntlMessages id="global.manager.title" />,
    icon: <ToolFilled />,
    permission: null,
    children: [
      {
        key: '/app/menu-manager',
        label: <IntlMessages id="global.manager.list" />,
        icon: <UnorderedListOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/role-menu',
        label: <IntlMessages id="global.manager.role" />,
        icon: <KeyOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/user-menu',
        label: <IntlMessages id="global.manager.user" />,
        icon: <UserOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'point',
    label: <IntlMessages id="global.point" />,
    icon: <UserSwitchOutlined />,
    permission: null,
    children: [
      {
        key: '/app/programs',
        label: <IntlMessages id="global.programs" />,
        icon: <UserSwitchOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/wallets',
        label: <IntlMessages id="global.wallets" />,
        icon: <WalletOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'voice',
    label: <IntlMessages id="global.voice" />,
    icon: <AudioOutlined />,
    permission: null,
    children: [
      {
        key: '/app/voice-posts',
        label: (
          <IntlMessages id="global.voice_posts" defaultMessage="Voice Posts" />
        ),
        icon: <SoundOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/voice-boost',
        label: (
          <IntlMessages id="voice_boost.title" defaultMessage="Voice Boost" />
        ),
        icon: <RiseOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/voice-trending',
        label: (
          <IntlMessages id="voice_trending.title" defaultMessage="Voice Trending" />
        ),
        icon: <FireOutlined />,
        permission: null,
        children: null,
      },
      // {
      //   key: '/app/voice-home-widgets',
      //   label: (
      //     <IntlMessages
      //       id="voice_home_widgets.title"
      //       defaultMessage="Voice Home Widgets"
      //     />
      //   ),
      //   icon: <AppstoreOutlined />,
      //   permission: null,
      //   children: null,
      // },
      {
        key: '/app/voice-hashtags',
        label: (
          <IntlMessages
            id="voice_hashtags.title"
            defaultMessage="Voice Hashtags"
          />
        ),
        icon: <TagOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/voice-view-report',
        label: (
          <IntlMessages
            id="voice_view_report.title"
            defaultMessage="Voice Play Report"
          />
        ),
        icon: <EyeOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/voice-duration-report',
        label: (
          <IntlMessages
            id="voice_duration_report.title"
            defaultMessage="Voice Duration Report"
          />
        ),
        icon: <FieldTimeOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/feed-simulator',
        label: (
          <IntlMessages
            id="feed_simulator.title"
            defaultMessage="Feed Simulator"
          />
        ),
        icon: <MobileOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/voice-view-log',
        label: (
          <IntlMessages
            id="voice_view_log.title"
            defaultMessage="Voice Play Log"
          />
        ),
        icon: <HistoryOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/reports',
        label: <IntlMessages id="global.reports" />,
        icon: <AlertOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/fake-comment-templates',
        label: <IntlMessages id="voice_posts.fake_comment_templates" />,
        icon: <CommentOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'credits',
    label: 'Voice Credit',
    icon: <CreditCardOutlined />,
    permission: null,
    children: [
      {
        key: '/app/credit-overview',
        label: 'Overview',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/credit-config',
        label: 'Credit Config',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/credit-packages',
        label: 'Credit Packages',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/credit-adjust',
        label: 'User Wallets',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      // Credit Lookup merged into Credit Transactions (filter by user shows balances)
      // {
      //   key: '/app/credit-wallet',
      //   label: 'User Credit Lookup',
      //   icon: <CreditCardOutlined />,
      //   permission: null,
      //   children: null,
      // },
      {
        key: '/app/credit-transactions',
        label: 'Credit Transactions',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/credit-purchases',
        label: 'Credit Purchases',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/voice-downloads',
        label: 'Voice Downloads',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/creator-earnings',
        label: 'Creator Earnings',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/creator-payouts',
        label: 'Creator Payouts',
        icon: <CreditCardOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'chat',
    label: <IntlMessages id="global.chat" />,
    icon: <MessageOutlined />,
    permission: null,
    children: [
      {
        key: '/app/chat',
        label: <IntlMessages id="global.chat" />,
        icon: <RedEnvelopeOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/audit-logs-chat',
        label: <IntlMessages id="global.audit-logs-chat" />,
        icon: <HistoryOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/chat-bot',
        label: <IntlMessages id="global.chat-bot" />,
        icon: <RobotOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/onboarding-chat',
        label: <IntlMessages id="onboarding_chat.menu" />,
        icon: <MessageOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
  {
    key: 'seo',
    label: <IntlMessages id="sidebar.seo" />,
    icon: <GlobalOutlined />,
    permission: null,
    children: [
      {
        key: '/app/seo/locations',
        label: <IntlMessages id="sidebar.seo.locations" />,
        icon: <EnvironmentOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seo/services',
        label: <IntlMessages id="sidebar.seo.services" />,
        icon: <AppstoreOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seo/additional-needs',
        label: <IntlMessages id="sidebar.seo.additionalNeeds" />,
        icon: <TagsOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/seo/translations',
        label: <IntlMessages id="sidebar.seo.translations" />,
        icon: <TranslationOutlined />,
        permission: null,
        children: null,
      },
    ],
  },
];

export const filterMenuByPermissions = (menus, allowedPaths) => {
  return menus
    .map((item) => {
      // Recursively filter children
      const filteredChildren = item.children
        ? filterMenuByPermissions(item.children, allowedPaths)
        : [];

      // Has access if key is allowed OR has accessible children
      const hasAccess =
        allowedPaths.includes(item.key) || filteredChildren.length > 0;

      if (!hasAccess) return null;

      // Return item with filtered children (or null if no children)
      return {
        ...item,
        children: filteredChildren.length > 0 ? filteredChildren : null,
      };
    })
    .filter(Boolean);
};

export const getFilteredMenu = () => {
  let allowedPaths = [];

  try {
    const storedPaths = localStorage.getItem('menu_paths');
    if (storedPaths) {
      allowedPaths = JSON.parse(storedPaths);
      // Validate it's an array
      if (!Array.isArray(allowedPaths)) {
        console.warn('menu_paths is not an array');
        allowedPaths = [];
      }
    }
  } catch (error) {
    console.error('Error reading menu_paths from localStorage:', error);
    allowedPaths = [];
  }

  return filterMenuByPermissions(menu, mergeContentExtraMenuPaths(allowedPaths));
};

export default menu;
